<template>
  <back-section :menu="nama" />
  <list-data-izin-all />
</template>
<script>
import ListDataIzinAll from "@/components/ListDataIzinAll.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      nama: "Daftar Izin Pegawai",
    };
  },
  components: { BackSection, ListDataIzinAll },
};
</script>
